// eslint-disable-next-line wandb/no-deprecated-imports
import {Input} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  padding-top: 4px;
  justify-content: flex-end;
`;

export const DeleteTeamInput = styled(Input)`
  width: 100%;
`;
